// extracted by css-extract-rspack-plugin
export default {"linkPreview":"LinkPreview_linkPreview__SYhKE"};